import { render, staticRenderFns } from "./TelaPlanos.vue?vue&type=template&id=7b4dd966&scoped=true"
import script from "./TelaPlanos.vue?vue&type=script&lang=js"
export * from "./TelaPlanos.vue?vue&type=script&lang=js"
import style0 from "./TelaPlanos.vue?vue&type=style&index=0&id=7b4dd966&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4dd966",
  null
  
)

export default component.exports